module.exports = __webpack_public_path__ + "img/loaderLoop.3f15d1b4.gif";